import request from "@/utils/request/index";

export enum Api {
  GET_VERIFICATIONCODE = "/sys/sms/getVerificationCode",
  LOGIN = "/sys/loginByMobile",
  QRCODE = '/sys/getQRCode',
  QRINFO = '/sys/qrcodeInfo',
  OCDEPHONE = '/sys/smsLoginOrRegisterCode',
  LOGINPHONE = '/sys/userLoginByMobile'
}
// 获取微信二维码
export const getQrCode = (data?: any) =>
  request.get(Api.QRCODE, data, {
    authorization: false,
  });

// 获取个人信息 轮询
export const getQrInfo = (data?: any) =>
  request.get(Api.QRINFO, data, {
    authorization: false,
  });

// 获取短信验证码
export const getPhoneCode = (data?: any) =>
  request.get(Api.OCDEPHONE+'/'+data, '', {
    authorization: false,
  });

// 手机号登录
export const loginPhone = (data?: any) =>
  request.post(Api.LOGINPHONE, data, {
    authorization: false,
  });

export const login = (data: any) =>
  request.post(Api.LOGIN, data, {
    authorization: false,
  });
